export default "__VITE_ASSET__BQUm_ROv__"